module Meevo.Plugins.DrawerManager {
    "use strict";

    export class PayInSection extends Meevo.Plugins.DrawerManager.DrawerManagerSectionBase {

        public amount: number;
        public payInReason: Meevo.Model.PayInOutReasons;
        public reasons: Meevo.Model.PayInOutReasons[];
        public note: string;
        public payInDate: Date;
        public payInTimeSegmented: any;
        public payInTime: any;
        public paymentCategory: Model.PaymentCategoryEnum;
        public checkNumber: string;

        public payInId: string;

        public isSaved: boolean = false;
        canSave = true;

        constructor(protected drawerManagerContext: Meevo.Plugins.DrawerManager.DrawerManagerContext,
            protected dataService: Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected printService: Meevo.Components.Common.IPrintService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            private $translate: angular.translate.ITranslateService,
            personalHeader: boolean,
            personalFooter: boolean) {

            super(DrawerManager.DrawerManagerSectionTypeEnum.PayIn, drawerManagerContext, "payIn", personalHeader, personalFooter);

            this.loadReasons();

            this.payInTimeSegmented = {
                value: moment("09:00", "HH:mm").toDate()
            };
            this.payInDate = moment(new Date()).toDate();
        }

        payInDateTimeChanged() {
            var time = moment(this.payInTimeSegmented.value.getHours() + ":" + this.payInTimeSegmented.value.getMinutes(), "h:m a").toDate();
            this.payInTime = moment(this.payInDate).startOf('day')
                .hours(moment(time).hours())
                .minutes(moment(time).minutes())
                .toDate();
        }
        loadReasons = () => {
            this.dataService.getListPaged("payInOutReasons",
                {
                    criteria: {
                        payInOutType: Meevo.Model.PayInOutEnum.PayIn
                    },
                    itemsPerPage: 1000
                })
                .then((data) => {
                    this.reasons = data;
                });
        }

        reset() {
            this.payInId = null;
            super.reset();
            this.amount = null;
            this.payInReason = null;
            this.note = null;
            this.paymentCategory = Model.PaymentCategoryEnum.Cash;
            this.checkNumber = null;

            this.payInDate = this.context.getPayInOutDate();
        }

        initialize(payIn: Meevo.Model.PayInOut) {
            this.payInId = payIn.id;
            this.amount = payIn.cashAmount;
            this.checkNumber = payIn.checkNumber;
            this.paymentCategory = payIn.paymentCategory;
            for (var i = 0; i < this.reasons.length; i++) {
                if (this.reasons[i].displayName == payIn.reason.displayName) {
                    this.payInReason = this.reasons[i];
                    break;
                }
            }
            this.note = payIn.note;
            this.populateDateTime(payIn);
        }

        getSectionName() {
            return this.context.selectedDrawer.displayName + " - " + this.$translate.instant(this.payInId ? "LABEL_PAY_IN_ADD_CASH" : this.context.getPayInAddCashLabelKey());
        }

        testNote() {
            this.note = "Testing: " + new Date().toString();
        }

        printReceipt() {
            if (!Number(this.amount) || !this.payInReason) {
                return;
            }
            if (!this.isSaved) {
                this.modalService.confirm("MESSAGE_PAY_IN_PRINT").then((result) => {
                    if (result) {
                        this.save(true);
                    }
                });
            } else {
                var options = {
                    url: `/api/PayIn/${this.payInId}/Receipt`,
                    method: 'GET',
                    params: {
                        locale: this.appSettings.APP_COUNTRYID,
                        timeFormat: this.appSettings.APP_TIME_FORMAT,
                    }
                };
                // TODO: this.context.selectedPrinter must match the one selected in the print service
                this.printService.printCustom(options).then(() => {
                    this.cancel();
                });
            }
        }

        getReasons = () => {
            return this.reasons;
        }

        save = (doPrint = false) => {
            if (!Number(this.amount)
                || !this.payInReason
                || (this.paymentCategory === Model.PaymentCategoryEnum.Check && !this.checkNumber)
                || (this.checkNumber && !Number(this.checkNumber))
            ) {
                return;
            }
            var payInObj: Meevo.Model.PayInOut = {
                id: this.payInId,
                cashAmount: Number(this.amount),
                reason: this.payInReason,
                note: this.note,
                payInOutType: Meevo.Model.PayInOutEnum.PayIn,
                drawerId: this.context.selectedDrawer.id,
                drawerSessionId: this.context.selectedDrawer.drawerSession.id,
                paymentCategory: this.paymentCategory,
                checkNumber: this.paymentCategory === Model.PaymentCategoryEnum.Check ? this.checkNumber : null
            };

            if (this.context.selectedDrawer.drawerState == Model.DrawerStateEnum.Close) {
                var time = moment(this.payInTimeSegmented.value.getHours() + ":" + this.payInTimeSegmented.value.getMinutes(), "h:m a").toDate();
                payInObj.payInOutDateTime = moment(this.payInDate).startOf('day')
                    .hours(moment(time).hours())
                    .minutes(moment(time).minutes()).format("YYYY-MM-DD HH:mm:ss")
                    .toString();
            }

            this.canSave = false;
            this.context.payInCash(payInObj)
                .then((response) => {
                    this.payInId = response.id;

                    this.context.getDrawerSession(this.context.selectedDrawer.id, true, this.context.selectedDrawer.drawerSession.id).then((data) => {
                        this.context.getDrawerSessionPayInOut(Model.PaymentCategoryEnum.Cash);
                        this.isSaved = true;

                        if (doPrint) {
                            this.printReceipt();
                        } else {
                            this.cancel();
                        }
                    });
                })
                .finally(() => {
                    this.canSave = true;
                });
        }

        cancel() {
            this.context.closeSection();
            this.isSaved = false;
        }

        populateDateTime(payIn) {
            if (this.context.selectedDrawer.drawerState == Model.DrawerStateEnum.Close) {
                var time = payIn.dateCreated.getHours() + ":" + payIn.dateCreated.getMinutes();
                this.payInTimeSegmented = {
                    value: moment(time, "HH:mm").toDate()
                };
                this.payInDate = moment(payIn.dateCreated).toDate();
            }
        }
    }

}